/*!
 * (c) 2026 Ocean Essentials Limited (HK). All rights reserved.
 * Proprietary code. Licensed, not sold. See LICENSE.md and Services Agreement.
 */

/**
 * Pack Variant Picker -- Modal
 * Handles 2-dimension pack selection (Board Size + Rig).
 * Reads JSON data from #pvp-data-{sectionId}.
 * Version: 1.0.0
 */
(function () {
  "use strict";

  if (window.__exocetPackPickerInit) return;
  window.__exocetPackPickerInit = true;
  var pickers = new Map();
  function initAll(root) {
  (root || document).querySelectorAll('[id^="pvp-data-"]').forEach(function (script) {
    var data;
    try {
      data = JSON.parse(script.textContent);
    } catch (e) {
      return;
    }
    initPicker(data);
  });
  }
  initAll();
  document.addEventListener("shopify:section:load", function (event) { initAll(event.target); });
  document.addEventListener("shopify:section:unload", function (event) {
    pickers.forEach(function (picker, id) {
      if (event.target.contains(picker.overlay)) { picker.destroy(); pickers.delete(id); }
    });
  });

  function initPicker(data) {
    var sid = data.sectionId;
    var overlay = document.getElementById("pvp-overlay-" + sid);
    if (!overlay || pickers.get(sid)?.overlay === overlay) return;
    if (pickers.has(sid)) pickers.get(sid).destroy();
    var events = new AbortController();
    function listen(target, type, handler) {
      target.addEventListener(type, handler, { signal: events.signal });
    }
    pickers.set(sid, { overlay: overlay, destroy: function () { closeModal(); events.abort(); } });

    var boardGrid = overlay.querySelector('[data-pvp-board-grid="' + sid + '"]');
    var rigGrid = overlay.querySelector('[data-pvp-rig-grid="' + sid + '"]');
    var notice = overlay.querySelector('[data-pvp-notice="' + sid + '"]');
    var selectionEl = overlay.querySelector('[data-pvp-selection="' + sid + '"]');
    var priceRow = overlay.querySelector('[data-pvp-price-row="' + sid + '"]');
    var confirmBtn = overlay.querySelector('[data-pvp-confirm="' + sid + '"]');
    var boardDisplay = document.querySelector('[data-pvp-board-display="' + sid + '"]');
    var rigDisplay = document.querySelector('[data-pvp-rig-display="' + sid + '"]');

    var selectedBoard = data.currentBoard;
    var selectedRig = data.currentRig;
    var siblings = data.siblings;

    function getTranslation(key) {
      var translations = data.translations || {};
      return translations[key] || "";
    }

    function getLowStockLabel(quantity) {
      var key = quantity === 1 ? "lowStockOne" : "lowStockOther";
      return getTranslation(key).replace("__COUNT__", quantity);
    }

    // Build unique board sizes and rig options (rebuilt on swap)
    var boardSizes = [];
    var rigOptions = [];

    function buildOptions() {
      boardSizes = [];
      rigOptions = [];
      var seen = {};
      siblings.forEach(function (s) {
        if (s.board && !seen["b_" + s.board]) {
          boardSizes.push(s.board);
          seen["b_" + s.board] = true;
        }
        if (s.rig && !seen["r_" + s.rig]) {
          rigOptions.push(s.rig);
          seen["r_" + s.rig] = true;
        }
      });
      rigOptions.sort(function (a, b) {
        var aNum = parseFloat(a.replace(/[^\d.]/g, "")) || 0;
        var bNum = parseFloat(b.replace(/[^\d.]/g, "")) || 0;
        if (aNum !== bNum) return aNum - bNum;
        return a.localeCompare(b);
      });
    }

    function renderGrids() {
      if (boardGrid && data.showBoardSection) renderBoardGrid();
      if (rigGrid) renderRigGrid();
    }

    buildOptions();
    renderGrids();
    updateFooter();

    // Open modal
    document.querySelectorAll('[data-pvp-open="' + sid + '"]').forEach(function (btn) {
      listen(btn, "click", openModal);
    });

    // Close modal
    document.querySelectorAll('[data-pvp-close="' + sid + '"]').forEach(function (btn) {
      listen(btn, "click", closeModal);
    });

    listen(overlay, "click", function (e) {
      if (e.target === overlay) closeModal();
    });

    listen(document, "keydown", function (e) {
      if (e.key === "Escape" && overlay.classList.contains("active")) {
        closeModal();
      }
    });

    // Confirm -- swap in place (no reload) via the shared helper; fall back to
    // a full navigation if the helper or the section wrapper is unavailable.
    if (confirmBtn) {
      listen(confirmBtn, "click", function () {
        var match = findMatch(selectedBoard, selectedRig);
        if (!match || !match.available || match.url === data.currentUrl) return;

        var section =
          overlay.closest(".product-hero-2026") ||
          document.querySelector('.product-hero-2026[data-section-id="' + sid + '"]');

        if (!section || !window.ExocetVariantSwap) {
          window.location.href = match.url;
          return;
        }

        var targetUrl = match.url;
        closeModal();
        window.ExocetVariantSwap.swap({
          section: section,
          sectionId: sid,
          url: targetUrl,
          variant: {
            variantId: match.variantId,
            price: match.price,
            compare_at_price: match.compareAtPrice,
          },
          onAfterSwap: function (doc) {
            refreshPackPicker(doc);
          },
        });
      });
    }

    function openModal() {
      overlay._pvpTrigger = document.activeElement;
      overlay.classList.add("active");
      overlay.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
      var firstBtn = overlay.querySelector(".pvp__modal-close");
      if (firstBtn) firstBtn.focus();
      if (typeof trapFocus === "function") trapFocus(overlay, firstBtn);
    }

    function closeModal() {
      if (!overlay.classList.contains("active")) return;
      if (typeof removeTrapFocus === "function") removeTrapFocus();
      overlay.classList.remove("active");
      overlay.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
      if (overlay._pvpTrigger) {
        overlay._pvpTrigger.focus();
        overlay._pvpTrigger = null;
      }
    }

    function renderBoardGrid() {
      while (boardGrid.firstChild) boardGrid.removeChild(boardGrid.firstChild);
      boardSizes.forEach(function (size) {
        var stock = getBoardStock(size);
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "pvp__board-btn";
        btn.setAttribute("data-board", size);

        if (size === selectedBoard) btn.classList.add("pvp__board-btn--selected");
        if (stock.status === "out") btn.classList.add("pvp__board-btn--oos");

        var valSpan = document.createElement("span");
        valSpan.className = "pvp__board-value";
        valSpan.textContent = size;

        var stockSpan = document.createElement("span");
        stockSpan.className = "pvp__board-stock pvp__board-stock--" + stock.status;
        stockSpan.setAttribute("aria-hidden", "true");
        stockSpan.textContent = stock.label;

        btn.setAttribute("aria-label", size + ", " + stock.label);
        if (stock.status === "out") btn.setAttribute("aria-disabled", "true");

        btn.appendChild(valSpan);
        btn.appendChild(stockSpan);

        listen(btn, "click", function () {
          if (btn.classList.contains("pvp__board-btn--oos")) return;
          selectedBoard = size;
          renderBoardGrid();
          renderRigGrid();
          updateFooter();
        });

        boardGrid.appendChild(btn);
      });
    }

    function renderRigGrid() {
      while (rigGrid.firstChild) rigGrid.removeChild(rigGrid.firstChild);
      rigOptions.forEach(function (rig) {
        var stock = getRigStock(rig);
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "pvp__rig-btn";
        btn.setAttribute("data-rig", rig);

        if (rig === selectedRig) btn.classList.add("pvp__rig-btn--selected");
        if (stock.status === "out") btn.classList.add("pvp__rig-btn--oos");

        var valSpan = document.createElement("span");
        valSpan.className = "pvp__rig-value";
        valSpan.textContent = rig;

        var stockSpan = document.createElement("span");
        stockSpan.className = "pvp__rig-stock pvp__rig-stock--" + stock.status;
        stockSpan.setAttribute("aria-hidden", "true");
        stockSpan.textContent = stock.label;

        btn.setAttribute("aria-label", rig + ", " + stock.label);
        if (stock.status === "out") btn.setAttribute("aria-disabled", "true");

        btn.appendChild(valSpan);
        btn.appendChild(stockSpan);

        listen(btn, "click", function () {
          if (btn.classList.contains("pvp__rig-btn--oos")) return;
          selectedRig = rig;
          renderRigGrid();
          renderBoardGrid();
          updateFooter();
        });

        rigGrid.appendChild(btn);
      });
    }

    function getBoardStock(board) {
      var anyAvailable = false;
      var totalQty = 0;
      siblings.forEach(function (s) {
        if (s.board === board) {
          if (s.available) {
            anyAvailable = true;
            totalQty += s.inventory;
          }
        }
      });
      if (!anyAvailable) return { status: "out", label: getTranslation("soldOut") };
      if (totalQty > 0 && totalQty <= 3) return { status: "low", label: getLowStockLabel(totalQty) };
      return { status: "in", label: getTranslation("inStock") };
    }

    function getRigStock(rig) {
      var match = findMatch(selectedBoard, rig);
      if (!match) return { status: "out", label: getTranslation("soldOut") };
      if (!match.available) return { status: "out", label: getTranslation("soldOut") };
      if (match.inventory > 0 && match.inventory <= 3) {
        return { status: "low", label: getLowStockLabel(match.inventory) };
      }
      return { status: "in", label: getTranslation("inStock") };
    }

    function findMatch(board, rig) {
      for (var i = 0; i < siblings.length; i++) {
        if (siblings[i].board === board && siblings[i].rig === rig) {
          return siblings[i];
        }
      }
      return null;
    }

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      var parts = amount.split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      var fmt = data.moneyFormat || "\u20ac{{amount}}";
      return fmt
        .replace("{{amount}}", parts[0] + "." + parts[1])
        .replace("{{amount_no_decimals}}", parts[0])
        .replace("{{amount_with_comma_separator}}", parts[0].replace(",", ".") + "," + parts[1])
        .replace("{{amount_no_decimals_with_comma_separator}}", parts[0].replace(",", "."));
    }

    function buildSelectionContent(container) {
      while (container.firstChild) container.removeChild(container.firstChild);
      if (data.showBoardSection) {
        container.appendChild(document.createTextNode(getTranslation("board") + " "));
        var boardHL = document.createElement("span");
        boardHL.className = "pvp__highlight";
        boardHL.textContent = selectedBoard;
        container.appendChild(boardHL);
        container.appendChild(document.createTextNode(" + " + getTranslation("rig") + " "));
      } else {
        container.appendChild(document.createTextNode(getTranslation("rig") + " "));
      }
      var rigHL = document.createElement("span");
      rigHL.className = "pvp__highlight";
      rigHL.textContent = selectedRig;
      container.appendChild(rigHL);
    }

    function buildPriceContent(container, match) {
      while (container.firstChild) container.removeChild(container.firstChild);
      var priceEl = document.createElement("span");
      priceEl.className = "pvp__price-current";
      if (!match) {
        priceEl.textContent = "--";
        container.appendChild(priceEl);
        return;
      }
      priceEl.textContent = formatMoney(match.price);
      container.appendChild(priceEl);

      if (match.compareAtPrice && match.compareAtPrice > match.price) {
        var compareEl = document.createElement("span");
        compareEl.className = "pvp__price-compare";
        compareEl.textContent = formatMoney(match.compareAtPrice);
        container.appendChild(compareEl);

        var pct = Math.round((1 - match.price / match.compareAtPrice) * 100);
        var badgeEl = document.createElement("span");
        badgeEl.className = "pvp__price-badge";
        badgeEl.textContent = "-" + pct + "%";
        container.appendChild(badgeEl);
      }
    }

    function buildConfirmContent(btn, isCurrent) {
      while (btn.firstChild) btn.removeChild(btn.firstChild);
      var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      svg.setAttribute("width", "16");
      svg.setAttribute("height", "16");
      svg.setAttribute("viewBox", "0 0 24 24");
      svg.setAttribute("fill", "none");
      svg.setAttribute("stroke", "currentColor");
      svg.setAttribute("stroke-width", "2");

      var path = document.createElementNS("http://www.w3.org/2000/svg", "polyline");
      if (isCurrent) {
        path.setAttribute("points", "20 6 9 17 4 12");
      } else {
        path.setAttribute("points", "9 18 15 12 9 6");
      }
      svg.appendChild(path);
      btn.appendChild(svg);
      btn.appendChild(
        document.createTextNode(" " + getTranslation(isCurrent ? "currentSelection" : "viewThisPack")),
      );
    }

    // BIS container reference
    var bisContainer = overlay.querySelector('[data-pvp-bis="' + sid + '"]');

    function updateFooter() {
      var match = findMatch(selectedBoard, selectedRig);

      if (boardDisplay) boardDisplay.textContent = selectedBoard;
      if (rigDisplay) rigDisplay.textContent = selectedRig;

      if (selectionEl) buildSelectionContent(selectionEl);

      if (notice) {
        if (!match || !match.available) {
          notice.classList.add("pvp__notice--visible");
        } else {
          notice.classList.remove("pvp__notice--visible");
        }
      }

      if (priceRow) buildPriceContent(priceRow, match);

      if (confirmBtn) {
        var isCurrent = match && match.url === data.currentUrl;
        confirmBtn.disabled = !match || !match.available || isCurrent;
        buildConfirmContent(confirmBtn, isCurrent);
      }

      // BIS form toggle
      if (bisContainer) {
        if (match && !match.available) {
          // OOS combo with a valid variant -- show BIS form
          bisContainer.style.display = "";
          var bisForm = bisContainer.querySelector("[data-bis-form]");
          if (bisForm) {
            var nextVariant = String(match.variantId || "");
            if (bisForm.getAttribute("data-bis-variant-id") !== nextVariant && window.bisResetForm) window.bisResetForm(bisForm);
            bisForm.setAttribute("data-bis-variant-id", nextVariant);
          }
        } else {
          // Available or combo doesn't exist -- hide BIS form
          bisContainer.style.display = "none";
        }
      }
    }

    // Re-seed picker state from the freshly-swapped section, then re-render.
    // The fetched doc carries the new product's pvp-data (its own siblings,
    // currentBoard/Rig, currentUrl) -- authoritative, no client-side guessing.
    function refreshPackPicker(doc) {
      var script = doc.getElementById("pvp-data-" + sid);
      if (!script) return;
      var newData;
      try {
        newData = JSON.parse(script.textContent);
      } catch (e) {
        return;
      }
      data = newData;
      siblings = data.siblings;
      selectedBoard = data.currentBoard;
      selectedRig = data.currentRig;
      buildOptions();
      renderGrids();
      updateFooter();
    }
  }
})();
